import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { HoveredStyledTableRow } from "components/Common/Table/StyledTable.styles.ts";

export const Content = styled.div(({ theme }) => ({
	padding: "24px 32px 32px",
	[theme.breakpoints.down("md")]: {
		padding: 16
	}
}));

export const SectionTitle = styled.h2(({ theme }) => ({
	...theme.project.typography.heading.h6,
	color: theme.project.colors.fontColors.main,
	margin: "0 0 16px"
}));

export const TableContainer = styled(Box)({
	overflowX: "auto"
});

export const ClickablePromotionRow = styled(HoveredStyledTableRow)(({ theme }) => ({
	"&[aria-pressed='true']": {
		backgroundColor: theme.project.colors.backgroundColors["card:hover"]
	},
	"&:focus-visible": {
		outline: `2px solid ${theme.project.colors.primaryColors.main}`,
		outlineOffset: "-2px"
	}
}));
